import { Dispatch } from 'react'
import { getCurrencyFetch, getCurrencySuccess, getCurrencyError } from './actions'
import { CurrencyActions, CurrencyInfo } from './types'
import loggerService from '../../services/logger-service'
import currencyService from '../../services/currency-service'

export const getCurrency = (idPais: number) => {
  return async (dispatch: Dispatch<CurrencyActions>) => {
    try {
      dispatch(getCurrencyFetch())
      const currency: CurrencyInfo[] = await currencyService.getCurrency(idPais)
      dispatch(getCurrencySuccess(currency))
    } catch (error) {
      dispatch(getCurrencyError(true))
      loggerService.logError(`Fetch Stock: ${error.message}`, error.stack)
    }
  }
}
